import '../../styles/skills.css';
import Rubik from './../media/rubik';

export default function Skills() {
    return (
        <div className="skills-screen">


            <Rubik />

        </div>
    );
}